import axios from 'axios';
import urlify from '@/helpers/urlify';

export function fetchTransactions(filters) {
    return axios.get(`/transactions?${urlify(filters)}`);
}
export function fetchPartnerTransactions(partnerId, filters) {
    return axios.get(`/transactions/${partnerId}?${urlify(filters)}`);
}

export function patchTransaction(payload) {
    return axios.patch('/transactions', payload);
}

export function fetchTransactionsSums(filters) {
    return axios.get(`/transactions/sums?${urlify(filters)}`);
}
export function fetchPartnerTransactionsSums(partnerId, filters) {
    return axios.get(`/transactions/${partnerId}/sums?${urlify(filters)}`);
}
